import { ForestCrewListPanel } from '@features/Contractor/ForestCrew'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

const ForestCrewsRoute: React.FC = () => {
  const { contractorId } = Route.useParams()
  return <ForestCrewListPanel contractorId={contractorId} />
}

export const Route = createFileRoute('/contractor/$contractorId/resources/forest-crews')({
  component: ForestCrewsRoute,
  staticData: {
    breadcrumb: t('contractor.profile.resources.tabs.forestCrews'),
  },
})
